export default __webpack_public_path__ + "static/media/bxl-facebook.1940917e.svg";